export default {
  name: '资质荣誉',
  children: [
    {
      menuId: 1,
      name: '技术资质',
      url: 'credential',
    },
    {
      menuId: 2,
      name: '公司荣誉',
      url: 'cpyhonor',
    },
  ],
}
